import React, { useEffect, useState } from 'react';
// import Card from "../../components/elements/Card";
import AdminLayout from '../../components/layout/admin';
import Breadcrumbs from '../../components/elements/Breadcrumbs';
import { useMutation, useQuery } from '@tanstack/react-query';
import { showNotification } from '../../utilities/mantineNotification';
import {
  Avatar,
  Flex,
  Image,
  Indicator,
  Popover,
  Tabs,
  Text,
  ThemeIcon,
  Title,
  Card,
  Badge,
  Button,
  Group,
  Grid,
  Container,
  Center,
  TextInput,
  Stack
} from '@mantine/core';
import * as Unicons from '@iconscout/react-unicons';
import ModalConfirmation from '../../components/fragments/ModalConfirmation';
import { resetWidget } from '../../services/resetWidget';
import { useLocation, useParams } from 'react-router-dom';
import { detailUser } from '../../services/report-gamification';
import { getSharepointCdnFile } from '../../utilities';
import { CgGoogleTasks } from 'react-icons/cg';
import DataTables from '../../components/elements/DataTables';
import { Bar } from 'react-chartjs-2';
import { convertToLocalTime } from '../../utilities/convertToLocaleTime';

interface RouteParams {
  bid: any;
}

const DetailUserReportGamification = (props) => {
  const location = useLocation();
  const [data, setData] = useState([]);
  const [proses, setProses] = useState(true);

  const column = [
    {
      heading: 'Mission Name',
      props: 'missionName',
      id: 'missionName',
      sortable: true
    },
    {
      heading: 'Mission Type',
      props: 'missionType',
      id: 'missionType',
      sortable: true
    },
    {
      heading: 'Point',
      props: 'point',
      id: 'point',
      sortable: true
    },
    {
      heading: 'Experience',
      props: 'xp',
      id: 'xp',
      sortable: true
    },
    {
      heading: 'Status',
      props: 'status',
      id: 'status',
      sortable: true
    },
    {
      heading: 'Date In',
      props: (item) => <Text size="sm">{convertToLocalTime(item.dateIn)}</Text>,
      id: 'dateIn',
      sortable: true
    }
  ];

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const bid = queryParams.get('bid');
    if (bid) {
      handleFetchData(bid);
    }
  }, [location]);

  const handleFetchData = (d) => {
    setProses(true);
    const payload = {
      BinusianID: d
    };
    fetchCategory.mutate(payload);
  };

  const fetchCategory = useMutation({
    mutationFn: detailUser,
    onSuccess: (data) => {
      setData(data?.data?.data);
      console.log(data);
    },
    onError: (error: any) => {
      alert(error);
    },
    onSettled: () => {
      setProses(false);
    }
  });

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom' as const
      },
      title: {
        display: false,
        text: 'Chart.js Bar Chart'
      }
    }
  };

  const labels = data[0]?.perbandinganPoint?.map((item) => {
    return getMonthName(item.month) + ' ' + item.year;
  });

  const dataChart = {
    labels,
    datasets: [
      {
        label: 'Redeem',
        data: data[0]?.perbandinganPoint?.map(
          (item) => item.totalPointRedeemed
        ),
        backgroundColor: 'rgba(255, 99, 132, 0.5)'
      },
      {
        label: 'Earning',
        data: data[0]?.perbandinganPoint?.map((item) => item.totalPointAchived),

        backgroundColor: 'rgba(178, 222, 39, 0.5)'
      }
    ]
  };

  const dataChartMilestoneMission = {
    labels,
    datasets: [
      {
        label: 'Total Mission',
        data: data[0]?.milestoneMission?.map((item) => item.totalMission),
        backgroundColor: 'rgba(255, 99, 132, 0.5)'
      }
    ]
  };

  return (
    <AdminLayout>
      <Breadcrumbs
        pageTitle="Report Gamification"
        itemList={[
          {
            title: 'BCL&D Back Office',
            href: '#',
            icon: <Unicons.UilFileCopyAlt />
          },
          {
            title: 'Reward & Gamification',
            href: '../report-gamification'
          },
          {
            title: 'Detail Report Binusian',
            href: 'management/report-gamification/overview-binusian'
          }
        ]}
      />
      <Stack>
        <Card bg={'white'}>
          <Grid>
            <Grid.Col span={{ base: 12, md: 8, lg: 8 }}>
              <Flex>
                <Avatar
                  mr={10}
                  size={125}
                  radius={65}
                  src={getSharepointCdnFile(data[0]?.fotoUser)}
                />
                <>
                  <Stack gap={'xs'}>
                    <div>
                      <Title order={4}>{data[0]?.namaUser}</Title>
                      <Text size="sm">{data[0]?.job}</Text>
                    </div>
                    <Text size="sm">{data[0]?.shortDesc}</Text>
                  </Stack>
                </>
              </Flex>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
              <Stack gap={'xs'}>
                <Title
                  order={6}
                  style={{
                    color: 'purple'
                  }}
                >
                  Summary
                </Title>
                <Flex
                  style={{
                    justifyContent: 'space-between'
                  }}
                >
                  <Flex>
                    <ThemeIcon color="#F7DFF9" size="xl" mr={10}>
                      <CgGoogleTasks
                        style={{ width: '70%', height: '70%' }}
                        color="#7B2183"
                      />
                    </ThemeIcon>
                    <div>
                      <Text
                        size="md"
                        style={{
                          fontWeight: 'bold'
                        }}
                      >
                        {data[0]?.totalMissionFinished}
                      </Text>
                      <Text
                        size="sm"
                        style={{
                          color: 'gray'
                        }}
                      >
                        Mission Completed
                      </Text>
                    </div>
                  </Flex>
                  <Flex>
                    <ThemeIcon color="#F7DFF9" size="xl" mr={10}>
                      <CgGoogleTasks
                        style={{ width: '70%', height: '70%' }}
                        color="#7B2183"
                      />
                    </ThemeIcon>
                    <div>
                      <Text
                        size="md"
                        style={{
                          fontWeight: 'bold'
                        }}
                      >
                        {convertNumberToK(data[0]?.totalPointAchived)}
                      </Text>
                      <Text
                        size="sm"
                        style={{
                          color: 'gray'
                        }}
                      >
                        Total Point
                      </Text>
                    </div>
                  </Flex>
                </Flex>
              </Stack>
            </Grid.Col>
          </Grid>
        </Card>
        <Card>
          <Grid>
            <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
              <Stack gap={'xs'}>
                <Flex
                  style={{
                    justifyContent: 'space-between'
                  }}
                >
                  <Title order={5}>Redeem & Earning Point</Title>
                  <Stack gap={'xs'}>
                    <Text size="sm">Last 6 months</Text>
                  </Stack>
                </Flex>

                {!fetchCategory.isLoading && (
                  <>
                    <Bar options={options} data={dataChart} />
                  </>
                )}
              </Stack>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
              <Stack gap={'xs'}>
                <Flex
                  style={{
                    justifyContent: 'space-between'
                  }}
                >
                  <Title order={5}>Milestone Mission</Title>
                  <Stack gap={'xs'}>
                    <Text size="sm">Last 6 months</Text>
                  </Stack>
                </Flex>

                {!fetchCategory.isLoading && (
                  <>
                    <Bar options={options} data={dataChartMilestoneMission} />
                  </>
                )}
              </Stack>
            </Grid.Col>
          </Grid>
        </Card>
        <Card>
          <DataTables
            columns={column}
            loading={false}
            data={data[0]?.listMissionFinished || []}
          />
        </Card>
      </Stack>
    </AdminLayout>
  );
};

function checkIsEmailValid(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function convertNumberToK(num) {
  if (num > 999) {
    return (num / 1000).toFixed(1) + 'k';
  } else {
    return num;
  }
}

function getMonthName(month: number) {
  const monthNames = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember'
  ];

  return monthNames[month - 1];
}

export default DetailUserReportGamification;
